export default __webpack_public_path__ + "static/media/35-instru.f09e37e4.png";